import { jsonObject } from './States';
import ReactJson from '@microlink/react-json-view';

import { useRecoilValue } from 'recoil';

export default function JsonObjectViewer() {
  const queryResult = useRecoilValue(jsonObject);
  // const queryResult = useRecoilValue(jsonQueryResult)

  return (
    <ReactJson
      style={{ padding: 20 }}
      collapsed={1}
      theme="monokai"
      name={false}
      displayDataTypes={false}
      enableClipboard={false}
      sortKeys={true}
      src={queryResult || {}}
    />
  );
}
